import { css } from "@emotion/react";
import {
  ColorIcon,
  colors,
  HStack,
  VStack,
  NextLink,
  customEvent,
  ClickEventType,
} from "goi_common";

import dayjs from "dayjs";
import { Box } from "@chakra-ui/react";

interface Review {
  id: number;
  headline: string;
  score: number;
  created_at: string;
  user: {
    nickname: string;
  };
  isCurrent?: boolean;
  event: ClickEventType;
  good: string;
}

export function ReviewCard({
  id,
  headline,
  created_at,
  good,
  user,
  score,
  isCurrent,
  event,
}: Review) {
  return (
    <VStack
      gap={14}
      background={colors.white}
      width={"100%"}
      height="250px"
      borderRadius="20px"
      boxShadow="0px 0px 16px rgba(0, 0, 0, 0.08)"
      position="relative"
      margin="16px 0"
      css={css({
        opacity: "1",
      })}
    >
      <NextLink
        css={{ display: "flex", justifyContent: "end", alignItems: "center" }}
        href={`/review/${id}/`}
        onClick={() => {
          customEvent({
            newGtm: {
              path: event.path,
              trigger_and_target: event.trigger_and_target,
              text: `review-${id}`,
            },
          });
        }}
      >
        <HStack
          padding="22px 30px 0"
          alignItems="center"
          style={{ color: colors.warmGray700 }}
          gap={4}
          className="body3_m"
          as="button"
          css={{ cursor: "pointer", zIndex: 10 }}
        >
          더보기
          <ColorIcon name="icon-arrow-right-circle-mono" color={colors.warmGray700} size={16} />
        </HStack>
      </NextLink>
      <VStack gap={14} margin={"-36px 0px"}>
        <VStack gap={8} padding="0 32px">
          <div className="body3_m" style={{ color: colors.gray400 }}>
            {user.nickname}님 | {dayjs(created_at).format("YYYY년 M월 D일")}
          </div>

          <HStack gap={6} className="subtitle_14_sb">
            <HStack gap={1} margin="2.5px 0 0">
              {Array(score)
                .fill(0)
                .map((i) => (
                  <ColorIcon
                    key={i + Math.random() + "slickstar"}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <div>5</div>
          </HStack>
        </VStack>

        <VStack gap={8} padding="0 32px 30px">
          <Box
            className="subtitle_16_sb black"
            css={{
              width: "100%",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {headline}
          </Box>
          <Box
            className="body_14_m gray700"
            css={{
              width: "100%",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {good}
          </Box>
        </VStack>
      </VStack>
    </VStack>
  );
}
